import PropTypes from "prop-types"
import classnames from "classnames"
import styles from "./applet_limit_warning.module.scss"

const AppletLimitWarning = ({ className, user: { tier, appletQuota } }) => {
  const created = appletQuota.total - appletQuota.remaining
  const visible =
    !["legacy_pro", "pro"].includes(tier) && appletQuota.remaining > 0

  return visible ? (
    <div className={classnames(styles["applet-limit-warning"], { [styles[className]]: !!className })}>
      You&rsquo;re using {created} of {appletQuota.total} Applets
    </div>
  ) : null
}

AppletLimitWarning.propTypes = {
  user: PropTypes.shape({
    tier: PropTypes.string.isRequired,
    appletQuota: PropTypes.shape({
      total: PropTypes.number,
      remaining: PropTypes.number,
    }),
  }),
  className: PropTypes.string,
}

export default AppletLimitWarning
